import { render, staticRenderFns } from "./LessonPositions.vue?vue&type=template&id=627db1ae"
import script from "./LessonPositions.vue?vue&type=script&lang=js"
export * from "./LessonPositions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports